module.exports = __webpack_public_path__ + "img/banner.7cd0a3fe.jpg";